// SYNCED with crewbit-mobile/types/invoices.ts — if you edit one, edit the other
export type InvoiceSegment = 'active' | 'outstanding' | 'paid' | 'drafts' | 'cancelled' | 'all';

// §1.35 consumer drift (Cluster D Rule #33): refunded + partially_refunded
// are paid-family statuses. written_off (no-payment closure) joins cancelled
// in the Cancelled segment — operators don't need to distinguish "I cancelled
// this" from "I wrote this off" at the segment-tab level. The per-row status
// pill still shows the literal value so the distinction surfaces where it
// matters.
export const INVOICE_SEGMENTS: { key: InvoiceSegment; label: string; match: (s: string) => boolean }[] = [
  { key: 'active', label: 'Active', match: (s) => s !== 'cancelled' && s !== 'draft' && s !== 'refunded' && s !== 'written_off' },
  { key: 'outstanding', label: 'Outstanding', match: (s) => s === 'sent' || s === 'viewed' || s === 'overdue' },
  { key: 'paid', label: 'Paid', match: (s) => s === 'paid' || s === 'refunded' || s === 'partially_refunded' },
  { key: 'drafts', label: 'Drafts', match: (s) => s === 'draft' },
  { key: 'cancelled', label: 'Cancelled', match: (s) => s === 'cancelled' || s === 'written_off' },
  { key: 'all', label: 'All', match: () => true },
];
